import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { IEquipmentMaintenanceRecord } from '@apis/equipmentMaintenance';
import { ChevronDownIcon } from '@utils/icons';
import { formatYmd } from '@utils/dateUtils';
import { daysBetween } from '../../../../SchedulerPage/lib/timeScale';
import { maintenanceDay } from '../maintenanceDay';
import styles from './MaintenanceLog.module.css';

interface IMaintenanceLogProps {
  records: IEquipmentMaintenanceRecord[];
  tz: string;
  today: string;
}

/** Every completion on the asset, newest first, behind a "Done (N)" toggle. */
export function MaintenanceLog({ records, tz, today }: IMaintenanceLogProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.log}>
      <button type="button" className={styles.toggle} aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <span className={styles.caret} data-collapsed={!open}><ChevronDownIcon size={12} /></span>
        {t('equipment.detail.maintenance.doneGroup', { count: records.length })}
      </button>

      {open && (
        <ul className={styles.list}>
          {records.map((r) => {
            const late = daysBetween(r.dueDate, formatYmd(r.doneAt, tz));
            return (
              <li key={`${r.doneAt}-${r.title}`} className={styles.record}>
                <span className={styles.date}>{maintenanceDay(r.doneAt, tz, today)}</span>
                <span className={styles.what}>{r.title}</span>
                <span className={styles.who}>{r.doneByName}</span>
                <span className={styles.timing} data-late={late > 0}>
                  {late > 0
                    ? t('equipment.detail.maintenance.late', { count: late })
                    : t('equipment.detail.maintenance.onTime')}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
